import React from "react";
import { useNavigate } from "react-router-dom";

import AddSubProductFormModal from "./components/AddSubProductModal";
import ProductDetailPageLoader from "./components/ProductDetailPageLoader";
import ProductOverview from "./components/ProductOverview";
import SubProductDetailLog from "./components/SubProductDetailLog";
import SubProductDetailSheet from "./components/SubProductDetailSheet";
import UpdateSubProductModal from "./components/UpdateSubProductModal";
import {
  ProductDetailContextProvider,
  useProductDetailContext,
} from "./context/ProductDetailContext";
import SubProductItemSheet from "./sub-product-items";
import ProductDetailTable from "./table/ProductDetailTable";

import CustomHeader from "@/components/reusables/Headers.tsx";
import { ROUTES } from "@/constants/routes_sidebar/routes-constant";
import { ToolsConstants } from "@/constants/tools.constant";
import DataTableSlotContextProvider from "@/context/DataTableSlot";

const ProductDetailComp = (): JSX.Element => {
  const { isLoading, productDetails, productOverview } =
    useProductDetailContext();
  const { PRODUCTS } = ToolsConstants;
  const navigate = useNavigate();
  const [isShowAddSubProduct, setIsShowAddSubProduct] = React.useState(false);
  const [isShowEditSubProduct, setIsShowEditSubProduct] = React.useState(false);
  const [isShowItemsSheet, setIsShowItemsSheet] = React.useState(false);
  const [isShowSubProductDetailSheet, setIsShowSubProductDetailSheet] =
    React.useState(false);
  const [subProducDetailtLog, setSubProductDetailLog] = React.useState<{
    isOpen: boolean;
    itemName: string;
    subProductId: string;
    productId: string;
  } | null>(null);

  const handleBackButton = (): void => {
    navigate(`${ROUTES.TOOLS}${ROUTES.PRODUCTS}`);
  };

  if (isLoading) {
    return <ProductDetailPageLoader />;
  }
  const productOverviewData = [
    {
      label: PRODUCTS.TOTAL_SUB_PRODUCTS,
      value:
        Object.values(productOverview || {}).reduce(
          (sum, value) => sum + value,
          0,
        ) || "0",
    },
    {
      label: PRODUCTS.AVAILABLE,
      value: productOverview?.available || "0",
    },
    {
      label: PRODUCTS.SENT_TO_SITE,
      value: productOverview?.sentToSite || "0",
    },
    {
      label: PRODUCTS.ON_SITE,
      value: productOverview?.onsite || "0",
    },
    {
      label: PRODUCTS.CONSUMNED,
      value: productOverview?.consumed || "0",
    },
    {
      label: PRODUCTS.UNDER_REPAIR,
      value: productOverview?.repair || "0",
    },
  ];

  return (
    <div className='space-y-5'>
      <CustomHeader
        title={`${productDetails?.name} : ${ToolsConstants.PRODUCTS.SUBPRODUCTS}`}
        backBtn={handleBackButton}
      />
      <ProductOverview data={productOverviewData} />
      <ProductDetailTable
        toggleAddSubProductModal={() => setIsShowAddSubProduct(true)}
        toggleEditSubProductModal={() => setIsShowEditSubProduct(true)}
        toggleViewItems={() => setIsShowItemsSheet(!isShowItemsSheet)}
        setSubProductDetailLog={setSubProductDetailLog}
        toggleViewSubProduct={() => setIsShowSubProductDetailSheet(true)}
      />
      {isShowAddSubProduct && (
        <AddSubProductFormModal
          isOpen={isShowAddSubProduct}
          toggleAddSubProductModal={(): void =>
            setIsShowAddSubProduct(!isShowAddSubProduct)
          }
        />
      )}
      {isShowEditSubProduct && (
        <UpdateSubProductModal
          isOpen={isShowEditSubProduct}
          toggleUpdateSubProductModal={(): void =>
            setIsShowEditSubProduct(!isShowEditSubProduct)
          }
        />
      )}
      {isShowItemsSheet && (
        <SubProductItemSheet
          isOpen={isShowItemsSheet}
          toggleSubProductItemSheet={(): void =>
            setIsShowItemsSheet(!isShowItemsSheet)
          }
        />
      )}
      {subProducDetailtLog?.isOpen && (
        <SubProductDetailLog
          toggleSubProductDetail={() => setSubProductDetailLog(null)}
          {...subProducDetailtLog}
        />
      )}
      {isShowSubProductDetailSheet && (
        <SubProductDetailSheet
          isOpen={isShowSubProductDetailSheet}
          toggleSubProductDetailSheet={() =>
            setIsShowSubProductDetailSheet(!isShowSubProductDetailSheet)
          }
        />
      )}
    </div>
  );
};

const ProductDetailPage = (): JSX.Element => {
  return (
    <ProductDetailContextProvider>
      <DataTableSlotContextProvider>
        <ProductDetailComp />
      </DataTableSlotContextProvider>
    </ProductDetailContextProvider>
  );
};

export default ProductDetailPage;
